import { mapState, mapGetters } from 'vuex'
import ozCardListing from '@/components/oz-card/oz-card-listing'
import ozAds from '@/components/oz-ads'
import ozNeighborhoodsGuideAds from '@/components/oz-neighborhoods-guide-ads'
import select from '@/utils/select'
import { TRUNCATE_IMAGES, getVariationOf } from '@/store/experimentations'
import ozCardsContainer from './components/oz-cards-container'

const ozMarkdownBanner = () => import(/* webpackChunkName: "oz-markdown-banner" */ '@/pages/results/components/oz-markdown-banner')

export default {
  name: 'oz-results',

  data () {
    return {
      nearbyIndex: null,
      expansionIndex: null,
      maxResultsRender: 7,
    }
  },

  props: {
    listings: { type: Array, required: true },
    businessTypeContext: { type: String },
    isAdvertiserPage: { type: Boolean },
    displayType: { type: String, default: 'list' },
    shouldRenderAsLink: { type: Boolean, default: false },
    pagination: { type: Object, default: false },
    shouldShowNeighborhoodsGuideBanners: { type: Boolean, default: false },
    neighborhoodsGuideWidget: { type: Object, default: {} },
    shouldRenderDynamicTitle: { type: Boolean, default: false },
    shouldRenderWithoutDescription: { type: Boolean, default: false },
    isLeadPhoneModalVariation: { type: Boolean },
  },

  computed: {
    ...mapState('results', {
      filters: (state) => state.filters,
    }),

    ...mapGetters({
      getWidgetByCategory: 'page/getWidgetByCategory',
      pageCategory: 'page/getCategory',
      getPopup: 'map/getPopup',
    }),

    showImagePlaceholder:
      select(getVariationOf(TRUNCATE_IMAGES, ([, { showPlaceholder }]) => showPlaceholder)),

    mapPopupId () {
      const { listing } = this.getPopup || {}

      return listing && listing.id
    },

    markdownBannerUrl () {
      return this.getWidgetByCategory('MARKDOWN_PAGE_LINK')?.header?.href ?? ''
    },

    showMarkdownBanner () {
      const { currentPage } = this.pagination

      return currentPage === 1 && !!this.markdownBannerUrl
    },

    shouldShowAd () {
      if (this.isAdvertiserPage) { return false }
      const totalListings = this.listings.length

      return totalListings > 16
    },

    adPosition () {
      const totalListings = this.listings.length
      const positionRatio = totalListings >= 48 ? 0.5 : 0.72

      return Math.ceil(totalListings * positionRatio)
    },

    listListing () {
      let { listings } = this

      if (this.shouldShowAd) {
        // this is to avoid mutating the original array on the store
        listings = [...listings]
        listings.splice(this.adPosition, 0, { isAddPosition: true })
      }

      if (this.shouldShowNeighborhoodsGuideBanners) {
        listings = [...listings]
        listings.splice(4, 0, { isNeighborhoodsGuideAdPosition: true })
      }

      return listings
    },
  },

  methods: {
    expandedResultsIndex (expandedType) {
      return this.listings.findIndex(({ type }) => type === expandedType)
    },

    shouldRenderResult (index) {
      if (!this.maxResultsRender) return true

      const { addresses: [{ state = '' } = {}] = [] } = this.filters
      if (state !== 'Rio de Janeiro') return true

      return index < this.maxResultsRender
    },

    getListingPosition (index) {
      if (this.shouldShowAd && this.adPosition < index) return index - 1
      return index
    },
  },

  mounted () {
    // Rendering all results on client-side
    this.maxResultsRender = null
  },

  components: {
    ozAds,
    ozNeighborhoodsGuideAds,
    ozCardListing,
    ozMarkdownBanner,
    ozCardsContainer,
  },
}
